import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Anstallning } from '../../interfaces/anstallning.interface';

@Injectable()
export class AnstallningService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public getAnstallning(instance: string, anstallningId: string): Observable<Anstallning> {
    return this.http.get<Anstallning>(`${this.apiUrl}${instance}/anstallning/get/${anstallningId}`);
  }
}
